import TApplicationInviteUserSummary from './index.vue';

TApplicationInviteUserSummary.install = app => {
  app.component(TApplicationInviteUserSummary.name, TApplicationInviteUserSummary);
};

export default TApplicationInviteUserSummary;
